import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.083 3.707a7.13 7.13 0 0 0-4.614-2.094V.938h.687a.469.469 0 0 0 0-.938H6.844a.469.469 0 0 0 0 .938h.687v.675a7.1 7.1 0 0 0-3.334 1.072L3.75 2.24a1.14 1.14 0 0 0-.811-.337c-.307 0-.595.12-.812.337l-.677.679a1.15 1.15 0 0 0 0 1.62l.448.45a7.16 7.16 0 0 0-1.086 3.81c0 1.924.747 3.732 2.104 5.092A7.13 7.13 0 0 0 8 16c1.92 0 3.725-.75 5.083-2.11A7.16 7.16 0 0 0 15.187 8.8a7.16 7.16 0 0 0-2.104-5.092M2.114 3.58l.678-.679a.21.21 0 0 1 .296 0l.34.34a7.3 7.3 0 0 0-.973.976l-.34-.341a.21.21 0 0 1 0-.296M8 15.063c-3.446 0-6.25-2.81-6.25-6.264S4.554 2.535 8 2.535s6.25 2.81 6.25 6.264-2.804 6.264-6.25 6.264"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 3.413c-2.964 0-5.375 2.416-5.375 5.386S5.036 14.184 8 14.184s5.375-2.416 5.375-5.385c0-2.97-2.411-5.386-5.375-5.386m.469 9.809v-.548a.469.469 0 0 0-.938 0v.548a4.45 4.45 0 0 1-3.944-3.955h.538a.469.469 0 0 0 0-.937h-.538a4.45 4.45 0 0 1 3.944-3.954v.548a.469.469 0 0 0 .938 0v-.548a4.45 4.45 0 0 1 3.944 3.954h-.538a.469.469 0 0 0 0 .937h.538a4.45 4.45 0 0 1-3.944 3.955"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.156 8.528h-.66V6.632a.469.469 0 0 0-.938 0v2.365c0 .259.21.468.468.468h1.13a.469.469 0 0 0 0-.937"
    }, null, -1)
  ]))]))
}
export default { render: render }